<template>
  <v-container pa-0 mx-0 mt-2 fluid>
    <v-responsive id="company-header" class="primary--text" relaive>
      <div class="section_inner">
        <v-row class="mt-6 mt-md-3 pr-4">
          <v-col cols="12" sm="9" class="mt-2">
            <h1
              class="header-text display-60-30"
              v-html="getString(constants, 'CompaniesLobby_Title').Value"
            />
          </v-col>
          <v-col cols="12" sm="9" class="my-0 pt-0">
            <h2
              class="subheader-text display-26-20"
              v-html="getString(constants, 'CompaniesLobby_TitleText').Value"
            />
          </v-col>
          <v-col cols="12" sm="9" class="search-controls d-flex ">
            <Voice/>
            <span class="display-26-20 mx-4 mt-1 label-separator">{{
              getString(constants, 'CompaniesLobby_SerachBar_Or').Value
            }}</span>
            <v-select
              v-model="benefit"
              :items="benefits"
              item-value="Code"
              item-text="NameInHebrew"
              :label="
                getString(constants, 'CompaniesLobby_AllBenefitsText').Value
              "
              outlined
              solo
              class="sm-3 benefit-search"
              color="#ff7100"
              background-color="#fff"
              @change="searchBenefit"
            >
              <template v-slot:append>
                <v-icon>mdi-keyboard-arrow-down</v-icon>
              </template>
            </v-select>
          </v-col>
        </v-row>
      </div>
    </v-responsive>
  </v-container>
</template>

<script>
import Voice from '@/components/speechRecognition/voice';
export default {
  components: { Voice },
  data() {
    return {
      company: this.searchString,
      benefit: this.selectedBenefit
    };
  },
  props: {
    constants: {
      type: Object,
      required: true
    },
    benefits: {
      type: Array,
      required: true
    },
    selectedBenefit: {
      type: Number,
      required: false,
      default: null
    },
    searchString: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    searchCompany() {
      this.benefit = null;
      this.$emit('selectCompany', this.company);
    },
    searchBenefit() {
      this.company = '';
      this.$emit('selectBenefit', this.benefit);
    }
  }
};
</script>

<style scoped  lang="scss">
#company-header {
  background: transparent url('/img/company_lobby_mobile_plazma.png') top left
    no-repeat;
  background-size: cover;
  position: relative;
  overflow: unset;
  z-index: 5;
  height: 380px;
}

#company-header .theme--light.v-icon {
  color: $primary;
}

h1,
h2 {
  text-shadow: 0px 0px 5px #ffffff, 0px 0px 10px #ffffff, 0px 0px 10px #ffffff,
    0px 0px 20px #ffffff, 0px 0px 20px #ffffff, 0px 0px 20px #ffffff,
    0px 0px 20px #ffffff;
}

.header-text {
  text-align: center;
  line-height: 1.2;
}

.subheader-text {
  text-align: center;
  width: 80%;
  line-height: 1.2;
  margin: auto;
}

.search-controls {
  flex-direction: column;
  align-items: center;
}

#search-companies ::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #ff7100 !important;
}
#search-companies ::-moz-placeholder {
  /* Firefox 19+ */
  color: #ff7100 !important;
}
#search-companies :-ms-input-placeholder {
  /* IE 10+ */
  color: #ff7100 !important;
}
#search-companies :-moz-placeholder {
  /* Firefox 18- */
  color: #ff7100 !important;
}

.search-input,
.benefit-search {
  width: 250px;
  max-width: 250px;
}

@media only screen and (max-width: 960px) and (min-width: 600px) {
  .header-text {
    font-size: 32px;
  }

  .subheader-text {
    font-size: 22px;
  }
}

@media only screen and (min-width: 600px) {
  #company-header {
    background: transparent url('/img/company_lobby_pc_plazma.jpg') bottom
      center no-repeat;
    height: 315px;
    background-size: cover;
    position: relative;
    overflow: unset;
    // z-index: 5;
  }

  .header-text {
    text-align: right;
  }

  .subheader-text {
    text-align: right;
    width: 100%;
  }

  .search-controls {
    flex-direction: row;
    align-items: flex-start;
  }
  .search-input {
    max-width: 400px;
  }

  .label-separator {
    max-width: 25px;
  }
}
</style>
